import { render, staticRenderFns } from "./ClassPeriod.vue?vue&type=template&id=4ab11bac&scoped=true&"
import script from "./ClassPeriod.vue?vue&type=script&lang=js&"
export * from "./ClassPeriod.vue?vue&type=script&lang=js&"
import style0 from "./ClassPeriod.vue?vue&type=style&index=0&id=4ab11bac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab11bac",
  null
  
)

export default component.exports